import { render, staticRenderFns } from "./ItemColor.vue?vue&type=template&id=711b0764"
import script from "./ItemColor.vue?vue&type=script&lang=ts"
export * from "./ItemColor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports